/*
 * @Author: Ryan
 * @Date: 2026-02-02
 * @Description: AI Image Translator 首屏展示图片数据
 */

export interface ImageCompareShowcase {
  id: string;
  beforeUrl: string;
  afterUrl: string;
  thumbnailUrl: string;
  label: string;
}

export const SHOWCASE_IMAGES: ImageCompareShowcase[] = [
  {
    id: 'en-to-es-business-process-diagram',
    beforeUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-es-business-process-diagram-before.webp',
    afterUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-es-business-process-diagram-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-es-business-process-diagram-after.webp',
    label: 'EN → ES',
  },
  {
    id: 'en-to-fr-restaurant-menu',
    beforeUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-fr-restaurant-menu-before.webp',
    afterUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-fr-restaurant-menu-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-fr-restaurant-menu-after.webp',
    label: 'EN → FR',
  },
  {
    id: 'en-to-de-advertising-banner',
    beforeUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-de-advertising-banner-before.webp',
    afterUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-de-advertising-banner-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-de-advertising-banner-after.webp',
    label: 'EN → DE',
  },
  {
    id: 'en-to-fr-knowledge-graph',
    beforeUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-fr-knowledge-graph-before.webp',
    afterUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-fr-knowledge-graph-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-fr-knowledge-graph-after.webp',
    label: 'EN → FR',
  },
  {
    id: 'en-to-ja-horizontal-infographic',
    beforeUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-ja-horizontal-infographic-before.webp',
    afterUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-ja-horizontal-infographic-after.webp',
    thumbnailUrl:
      'https://assets.falcocut.ai/ai-image-translator/en-to-ja-horizontal-infographic-after.webp',
    label: 'EN → JA',
  },
];
